import { PhoneIcon, TelegramIcon, VKIcon, WhatsAppIcon } from '@/utils/icons'
import { WazzupGetFields } from '@pages/Admin/PlatformSettings2/ServiceIntegrations/components/WazzupIntegrationSettings/type'

export type CRMIntegrationType = 'whatsapp' | 'tgapi' | 'vk' | 'telegram' | 'wapi' | 'phone'

export const CRM_INTEGRATIONS: ReadonlyArray<{
  key: CRMIntegrationType
  icon: React.FC<React.SVGProps<SVGSVGElement>>
  label: string
  color: string
  is_wazzup: boolean
  is_disabled_for_lead?: boolean
}> = [
  {
    key: 'whatsapp',
    icon: WhatsAppIcon,
    label: 'WhatsApp',
    color: '#25D366',
    is_wazzup: true,
  },
  {
    key: 'tgapi',
    icon: TelegramIcon,
    label: 'Telegram',
    color: '#0088CC',
    is_wazzup: true,
  },
  {
    key: 'vk',
    icon: VKIcon,
    label: 'VKontakte',
    color: '#4C75A3',
    is_wazzup: true,
    is_disabled_for_lead: true,
  },
  {
    key: 'telegram',
    icon: TelegramIcon,
    label: 'Telegram Bot',
    color: '#0088CC',
    is_wazzup: true,
    is_disabled_for_lead: true,
  },
  {
    key: 'wapi',
    icon: WhatsAppIcon,
    label: 'WhatsApp Business API',
    color: '#25D366',
    is_wazzup: true,
    is_disabled_for_lead: true,
  },
  {
    key: 'phone',
    icon: PhoneIcon,
    label: 'Phone',
    color: '#9747FF',
    is_wazzup: false,
    is_disabled_for_lead: true,
  },
] as const

type FilterByWazzup<T extends readonly any[]> = {
  [K in keyof T]: T[K] extends { is_wazzup: true; key: infer U } ? U : never
}[number]

export type CRMWazzupIntegrationType = FilterByWazzup<typeof CRM_INTEGRATIONS>

const checkActiveWazzupChannel = (
  wazzupIntegrationsData: WazzupGetFields,
  name: string,
) => {
  const val = wazzupIntegrationsData?.channels[name]
  if (val === false || val === undefined || val === null) return false
  return true
}

export const getCrmIntegrations = (wazzupIntegrationsData: WazzupGetFields | undefined) =>
  CRM_INTEGRATIONS.map((i) => ({
    ...i,
    is_active: i.is_wazzup && wazzupIntegrationsData
      ? checkActiveWazzupChannel(wazzupIntegrationsData, i.key)
      : false, // если не wazzup, то не активно (пока) --- "phone"
  }))
